class Asset {
  constructor({
    uuid,
    type,
    organisation,
    standard,
    createdAt,
    assetId,
    upstreamNode,
    downstreamNode,
    diameter,
    material,
    locationStreet,
    locationTown,
    pipeType,
    repairCompletedDate,
    inspectionsCount,
    extraFields,
  } = {}) {
    this.uuid = uuid;
    this.type = type;
    this.organisation = organisation;
    this.standard = standard;
    this.createdAt = createdAt;
    this.assetId = assetId;
    this.upstreamNode = upstreamNode;
    this.downstreamNode = downstreamNode;
    this.diameter = diameter;
    this.material = material;
    this.locationStreet = locationStreet;
    this.locationTown = locationTown;
    this.pipeType = pipeType;
    this.repairCompletedDate = repairCompletedDate;
    this.inspectionsCount = inspectionsCount;
    this.extraFields = extraFields;
  }

  static fromServerModel(data = {}) {
    return new Asset({
      uuid: data.uuid,
      type: data.type,
      standard: data.standard,
      organisation: data.organisation,
      createdAt: data.createdAt,
      assetId: data.AssetID,
      upstreamNode: data.UpstreamNode,
      downstreamNode: data.DownstreamNode,
      diameter: data.HeightDiameter,
      material: data.Material,
      locationStreet: data.LocationStreet,
      locationTown: data.LocationTown,
      pipeType:
        data.UseOfDrainSewer === "SS"
          ? "Sewer"
          : data.UseOfDrainSewer === "SW"
          ? "Stormwater"
          : data.UseOfDrainSewer,
      inspectionsCount: data.inspectionsCount,
      extraFields: data.extraFields,
    });
  }

  toServerModel() {
    return {
      type: this.type,
      organisation: this.organisation,
      standard: this.standard,
      AssetID: this.assetId,
      UpstreamNode: this.upstreamNode,
      DownstreamNode: this.downstreamNode,
      HeightDiameter: this.diameter,
      Material: this.material,
      LocationStreet: this.locationStreet,
      LocationTown: this.locationTown,
      UseOfDrainSewer: this.pipeType,
    };
  }
}

export default Asset;
